import { FileText } from 'lucide-react'

export function TermsOfServicePage() {
  return (
    <div className="bg-background-dark min-h-screen pb-24 pt-40">
      <div className="container max-w-[800px] mx-auto px-6">
        <div className="flex items-center gap-3 mb-8">
          <FileText className="w-10 h-10 text-game-primary" />
          <h1 className="text-white text-3xl md:4xl font-black">Terms of Service</h1>
        </div>
        
        <p className="text-slate-400 mb-8">Last updated: February 4, 2026</p>

        <div className="space-y-8 text-slate-300">
          <section>
            <h2 className="text-white text-2xl font-bold mb-4">1. Acceptance of Terms</h2>
            <p className="leading-relaxed">
              By accessing or using Polytoria's platform, website, and services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-white text-2xl font-bold mb-4">2. Description of Service</h2>
            <p className="leading-relaxed">
              Polytoria is a web-based gaming platform that allows users to play, create, and share interactive experiences. Our services include game hosting, marketplace features, social tools, and development resources.
            </p>
          </section>

          <section>
            <h2 className="text-white text-2xl font-bold mb-4">3. User Accounts</h2>
            <p className="leading-relaxed mb-4">To use certain features, you must create an account. You agree to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Provide accurate and complete registration information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Notify us immediately of any unauthorized access</li>
              <li>Accept responsibility for all activities under your account</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white text-2xl font-bold mb-4">4. User Content</h2>
            <p className="leading-relaxed mb-4">
              You retain ownership of content you create on Polytoria. By posting content, you grant us a worldwide, non-exclusive license to use, display, and distribute your content on our platform. You agree not to post content that:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Violates any applicable laws or regulations</li>
              <li>Infringes on intellectual property rights</li>
              <li>Contains harmful, offensive, or inappropriate material</li>
              <li>Impersonates others or misrepresents your identity</li>
              <li>Contains malware or malicious code</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white text-2xl font-bold mb-4">5. Virtual Currency & Purchases</h2>
            <p className="leading-relaxed">
              Polytoria may offer virtual currency and items for purchase. All purchases are final and non-refundable unless required by law. Virtual items have no real-world value and cannot be exchanged for real currency.
            </p>
          </section>

          <section>
            <h2 className="text-white text-2xl font-bold mb-4">6. Creator Program</h2>
            <p className="leading-relaxed">
              Creators may earn revenue from their games and assets. Revenue sharing terms are outlined in our Creator Agreement. We reserve the right to modify payout rates with reasonable notice.
            </p>
          </section>

          <section>
            <h2 className="text-white text-2xl font-bold mb-4">7. Prohibited Conduct</h2>
            <p className="leading-relaxed mb-4">You agree not to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Use cheats, exploits, or unauthorized third-party software</li>
              <li>Harass, bully, or threaten other users</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with the proper functioning of the platform</li>
              <li>Engage in real-world trading of virtual items</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white text-2xl font-bold mb-4">8. Termination</h2>
            <p className="leading-relaxed">
              We may suspend or terminate your account at any time for violations of these terms. Upon termination, your right to use the service ceases immediately. You may also delete your account at any time through your account settings.
            </p>
          </section>

          <section>
            <h2 className="text-white text-2xl font-bold mb-4">9. Disclaimer of Warranties</h2>
            <p className="leading-relaxed">
              The service is provided "as is" without warranties of any kind. We do not guarantee uninterrupted or error-free service. We are not responsible for user-generated content or third-party links.
            </p>
          </section>

          <section>
            <h2 className="text-white text-2xl font-bold mb-4">10. Limitation of Liability</h2>
            <p className="leading-relaxed">
              To the maximum extent permitted by law, Polytoria shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the service.
            </p>
          </section>

          <section>
            <h2 className="text-white text-2xl font-bold mb-4">11. Changes to Terms</h2>
            <p className="leading-relaxed">
              We may update these terms from time to time. Continued use of the service after changes constitutes acceptance of the new terms. We will notify users of significant changes via email or platform notification.
            </p>
          </section>

          <section>
            <h2 className="text-white text-2xl font-bold mb-4">12. Contact</h2>
            <p className="leading-relaxed">
              For questions about these Terms of Service, contact us at{' '}
              <a href="mailto:legal@polytoria.io" className="text-game-primary hover:underline">
                legal@polytoria.io
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}
